import React, { useState } from 'react'
import Slides from '../slides/Slides'
import { Link } from 'react-router-dom'

const Credenciales = ({M}) => {
   const [razonSocial,setRazonSocial] = useState("");
   const handleSearch = () =>{

   }
   return (
      <>
         <Slides M={M} tipoSlides={"credenciales"}></Slides>
         <div className="section animated fadeIn">
            <div className="row center">
               <h5 className="light-blue-text text-accent-3">CREDENCIALES DIGITALES ART</h5>
                  <div className="container">
                     <div className="row center">
                        <div className="input-field col s12 m5 l5 xl5">
                           <input type="number" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)}/>
                           <label htmlFor="polizaNumero" disabled="">Número de Póliza</label>
                        </div>
                        <div className="input-field col s12 m1 l1 x1">
                           <Link type="button" className="btn-floating waves-effect waves-light light-blue accent-3" onClick={()=>handleSearch()}><i className="material-icons left">search</i></Link>
                        </div>
                        <div className="input-field col s12 m1 l1 x1">
                           <Link type="button" className="btn waves-effect waves-orange purple darken-4 modal-trigger pulse">Descargar Credencial Vacía</Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
      </>
   )
}

export default Credenciales